export const FETCH_METRICS_REQUEST = "@DASHBOARD/FETCH_METRICS_REQUEST";
export const FETCH_METRICS_SUCCESS = "@DASHBOARD/FETCH_METRICS_SUCCESS";
export const FETCH_METRICS_FAILURE = "@DASHBOARD/FETCH_METRICS_FAILURE";
export const FETCH_CHART_VALUES_REQUEST = "@DASHBOARD/FETCH_CHART_VALUES_REQUEST";
export const FETCH_CHART_VALUES_SUCCESS = "@DASHBOARD/FETCH_CHART_VALUES_SUCCESS";
export const FETCH_CHART_VALUES_FAILURE = "@DASHBOARD/FETCH_CHART_VALUES_FAILURE";
